import carEClass from "../../static/ride-order/limo/car-e-class.png";
import carVClass from "../../static/ride-order/limo/car-v-class.png";
import carSClass from "../../static/ride-order/limo/car-s-class.png";
import carGle from "../../static/ride-order/limo/car-gle.png";
import carGClass from "../../static/ride-order/limo/car-g-class.png";
import elitVehiclesConfig from "./elitVehicles.config.json";

const VEHICLE_IMAGES: Record<string, string> = {
  "mercedes-e-class": carEClass,
  "mercedes-v-class": carVClass,
  "mercedes-s-class": carSClass,
  "mercedes-gle": carGle,
  "mercedes-g-class": carGClass,
};

export type ElitVehicleConfig = {
  id: string;
  name: string;
  apiCarModel: string;
  brand: string;
  model: string;
  specs: string;
  transferPrice: string;
  minHours: number;
  hourlyRate: string;
  dailyRate: string;
  pricePerKm: string;
  maxPassengers: number;
  maxLuggage: number;
};

export type OrderVehicle = ElitVehicleConfig & {
  image: string;
};

export const ORDER_VEHICLES: OrderVehicle[] = elitVehiclesConfig.vehicles.map((vehicle) => ({
  ...vehicle,
  image: VEHICLE_IMAGES[vehicle.id] ?? carEClass,
}));

export function getVehicleById(id: string): OrderVehicle {
  return ORDER_VEHICLES.find((v) => v.id === id) ?? ORDER_VEHICLES[0];
}
